import { render, staticRenderFns } from "./ShopTheLook.vue?vue&type=template&id=fd226670&"
import script from "./ShopTheLook.vue?vue&type=script&lang=js&"
export * from "./ShopTheLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-stylebreaker-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd226670')) {
      api.createRecord('fd226670', component.options)
    } else {
      api.reload('fd226670', component.options)
    }
    module.hot.accept("./ShopTheLook.vue?vue&type=template&id=fd226670&", function () {
      api.rerender('fd226670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/common/ShopTheLook.vue"
export default component.exports